var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66669 12.212C2.66669 10.4016 2.66669 9.49648 3.03264 8.70082C3.39858 7.90517 4.08584 7.31609 5.46036 6.13794L6.79369 4.99508C9.27811 2.86558 10.5203 1.80082 12 1.80082C13.4797 1.80082 14.7219 2.86558 17.2064 4.99508L18.5397 6.13794C19.9142 7.31609 20.6015 7.90517 20.9674 8.70082C21.3334 9.49648 21.3334 10.4016 21.3334 12.212V17.8658C21.3334 20.38 21.3334 21.6371 20.5523 22.4181C19.7713 23.1992 18.5142 23.1992 16 23.1992H8.00002C5.48586 23.1992 4.22878 23.1992 3.44774 22.4181C2.66669 21.6371 2.66669 20.38 2.66669 17.8658V12.212Z",
    stroke: "white",
    strokeWidth: 1.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 23.1992V16.5325C15.3334 15.7961 14.7364 15.1992 14 15.1992H10C9.26364 15.1992 8.66669 15.7961 8.66669 16.5325V23.1992",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.c8876beed1ab1987ad5ab074596c1c89.svg";
export { ForwardRef as ReactComponent };